import { useState, useEffect, useCallback } from "react";
import { get } from "../../../helpers/aws_api_helper";
import { getApiErrorMessage } from "../../../helpers/aws_api_helper";
import * as url from "../../../helpers/url_helper";

/**
 * Fetches ARN views summary from GET_ARN_VIEWS_SUMMARY.
 * Returns { data: { overall, services }, loading, error, refetch }.
 */
export function useSummaryData() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSummary = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await get(url.GET_ARN_VIEWS_SUMMARY);
      const status = response?.status;
      if (status >= 200 && status < 300) {
        const overall = response?.overall ?? null;
        const services = Array.isArray(response?.services) ? response.services : [];
        setData({ overall, services });
      } else {
        setError(getApiErrorMessage(response) || "Failed to load summary");
        setData(null);
      }
    } catch (err) {
      const errData = err?.data ?? err?.response?.data;
      setError(getApiErrorMessage(errData) || err?.message || "Failed to load summary");
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSummary();
  }, [fetchSummary]);

  return { data, loading, error, refetch: fetchSummary };
}
